import React from 'react';
import { Card } from '../common';

const NegotiationView = ({ data, isNewClient, onNewClientChange }) => {
    if (!data) return null;

    return (
        <div className="space-y-6">
            <div className="flex justify-between items-center mb-4">
                <h2 className="text-xl font-bold text-gray-900">Negotiation Summary</h2>
                <label className="flex items-center gap-2 cursor-pointer bg-gray-50 px-4 py-2 rounded-lg border border-gray-200 hover:bg-gray-100 transition-colors">
                    <input
                        type="checkbox"
                        checked={isNewClient || false}
                        onChange={(e) => onNewClientChange(e.target.checked)}
                        className="w-4 h-4 text-blue-600 rounded border-gray-300 focus:ring-blue-500"
                        data-testid="new-client-checkbox"
                    />
                    <span className="text-sm font-medium text-gray-700">New Client</span>
                </label>
            </div>
            <div className="space-y-4">
                {data.map((item, idx) => (
                    <Card key={idx} className="overflow-hidden border border-gray-200">
                        <div className="bg-gray-50 px-4 py-2 border-b border-gray-200 flex justify-between items-center">
                            <div className="flex flex-col">
                                <span className="font-bold text-gray-900">{idx + 1}. {item.title}</span>
                                {item.contract_section && (
                                    <span className="text-sm text-blue-600 font-medium">Contract Section: {item.contract_section}</span>
                                )}
                                {!item.contract_section && item.clause_reference && (
                                    <span className="text-xs text-gray-500 font-mono">{item.clause_reference}</span>
                                )}
                            </div>
                            <span className={`px-2 py-1 rounded text-xs font-bold ${
                                item.action?.toLowerCase() === 'strike' ? 'bg-red-100 text-red-700' :
                                item.action?.toLowerCase() === 'modify' ? 'bg-blue-100 text-blue-700' :
                                item.action?.toLowerCase() === 'request for documentation' ? 'bg-purple-100 text-purple-700' :
                                item.action?.toLowerCase() === 'request to incorporate' ? 'bg-green-100 text-green-700' :
                                item.action?.toLowerCase() === 'request acknowledgment' ? 'bg-yellow-100 text-yellow-700' :
                                item.action?.toLowerCase() === 'clarification requested' ? 'bg-orange-100 text-orange-700' :
                                'bg-gray-100 text-gray-700'
                            }`}>
                                {item.action}
                            </span>
                        </div>
                        <div className="p-4 space-y-4">
                            <div>
                                <div className="text-xs text-gray-500 uppercase tracking-wide mb-1">Current Language</div>
                                <div className="bg-white p-3 rounded border border-gray-200 text-sm text-gray-600 italic font-mono">
                                    {item.verbatim_text?.toLowerCase().includes("not addressed") 
                                        ? item.verbatim_text 
                                        : `"${item.verbatim_text}"`}
                                </div>
                            </div>
                            
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                <div>
                                    <div className="text-xs text-blue-600 uppercase tracking-wide mb-1 font-semibold">Response</div>
                                    <div className="bg-blue-50 p-3 rounded text-sm text-blue-900 font-medium">
                                        {item.clarification || item.proposal_text}
                                    </div>
                                </div>
                                <div>
                                    <div className="text-xs text-gray-500 uppercase tracking-wide mb-1">Comment</div>
                                    <div className="text-sm text-gray-700">
                                        {item.comment || item.reason}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Card>
                ))}
            </div>
        </div>
    );
};

export default NegotiationView;
